"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Path = void 0;
var SEPARATOR = '/';
var Path = /** @class */ (function () {
    function Path(path) {
        this.ids = path;
    }
    Path.prototype.empty = function () {
        return !this.ids.length;
    };
    Path.prototype.popRoot = function () {
        if (this.empty())
            throw new Error('No root without path');
        return [this.ids[0], new Path(this.ids.slice(1))];
    };
    Path.prototype.nodeId = function () {
        if (this.empty())
            throw new Error('No node id for an empty path');
        return this.ids[this.ids.length - 1];
    };
    Path.prototype.parentPath = function () {
        if (this.empty())
            throw new Error('No parent path without a path');
        return new Path(this.ids.slice(0, -1));
    };
    Path.prototype.childPath = function (nodeId) {
        return new Path(__spreadArray(__spreadArray([], __read(this.ids), false), [nodeId], false));
    };
    Path.prototype.descendantPath = function (relativePath) {
        return new Path(__spreadArray(__spreadArray([], __read(this.ids), false), __read(relativePath.ids), false));
    };
    Path.prototype.toString = function () {
        return this.ids.join(SEPARATOR);
    };
    return Path;
}());
exports.Path = Path;
//# sourceMappingURL=paths.js.map